import React from "react";
import { useNavigate } from "react-router-dom";
import OfficerDashboard from "../components/officerDashboard";
import Header from "../components/header";
import dashboardIcon2 from "../assets/images/grid-view2.png";
import logoutIcon from "../assets/images/logout.svg";
import AdminDashboard from "../components/adminDashboard";
import sidebarImage from "../assets/images/Rectangle 5191.png";
import { useAuth } from "../utils/AuthContext";

const AdminDesk = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleSignOut = () => {
    ["email", "name", "userId"].forEach((key) => sessionStorage.removeItem(key));
    logout();
    navigate("/");
  };

  return (
    <div className="flex flex-col h-[100dvh] overflow-hidden">
      <Header />
      {/* <AdminDashboard /> */}

      <div className="flex-1 flex flex-col sm:flex-row overflow-hidden">
        {/* Mobile Top Navigation */}
        <div className="flex sm:hidden w-full bg-[#F3F8FF] border-b border-[#E7E5E4] px-4 py-2 gap-3 justify-between overflow-x-auto shrink-0">
          <div className="flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-semibold shrink-0 whitespace-nowrap bg-gradient-to-r from-[#45B07B] to-[#12A57C] text-white">
            <img src={dashboardIcon2} alt="" className="w-4 h-4" />
            Dashboard
          </div>
          <button
            className="flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-semibold shrink-0 whitespace-nowrap bg-white text-black border border-[#E7E5E4]"
            onClick={() => navigate("/registerOfficer")}
          >
            Register Officer
          </button>

        </div>

        {/* Desktop Sidebar */}
        <aside className="hidden sm:flex w-[15%] min-w-[150px] flex-col items-center text-white gap-y-1 pt-4 shadow-lg bg-[#F3F8FF] shrink-0">
          <div className="mt-1 w-[95%] h-[40px] text-[14px] xl:text-[15px] rounded-lg flex items-center justify-center gap-x-3 px-2 font-semibold cursor-pointer shadow bg-gradient-to-r from-[#45B07B] to-[#12A57C] text-white whitespace-nowrap">
            <div className="w-[18px] h-[18px] overflow-hidden">
              <img src={dashboardIcon2} alt="dashboard" className="w-full h-full object-cover" />
            </div>
            Dashboard
          </div>
          <div
            className="mt-1 w-[95%] h-[40px] text-[14px] xl:text-[15px] border border-[#E7E5E4] rounded-lg flex items-center justify-center gap-x-3 px-2 font-semibold cursor-pointer bg-white text-black whitespace-nowrap"
            onClick={() => navigate("/registerOfficer")}
          >
            <span className="hover:underline">Register Officer</span>
          </div>
          <div className="mt-auto w-full flex flex-col items-center">
            <img src={sidebarImage} alt="Powered by Innovation" className="w-full max-w-[200px] h-auto opacity-70 object-contain mb-4" />
            <div
              className="w-[95%] mb-4 h-[40px] text-[14px] xl:text-[15px] shadow-inner rounded-3xl flex justify-center items-center gap-x-2 px-2 font-semibold cursor-pointer border border-[#D6D3D1] bg-[#F5F5F4] text-black whitespace-nowrap"
              onClick={handleSignOut}
            >
              <div className="w-[24px] h-[24px] overflow-hidden">
                <img src={logoutIcon} alt="logout" className="w-full h-full object-cover" />
              </div>
              Logout
            </div>
          </div>
        </aside>
        <main className="flex-1 overflow-y-auto">
          <AdminDashboard />
        </main>
      </div>

    </div>
  );
};

export default AdminDesk;
